import { AfterViewInit, Component, OnDestroy, inject, input } from '@angular/core';
import { MovieCompetitionService } from '@usheru-hff/sdk/movie';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';

@Component({
  selector: 'ush-movie-competition',
  standalone: true,
  templateUrl: './movie-competition.component.html',
  styleUrls: ['./movie-competition.component.scss'],
  imports: [LoadingIndicatorComponent]
})
export class MovieCompetitionComponent implements AfterViewInit, OnDestroy {
  private readonly movieCompetitionService = inject(MovieCompetitionService);

  readonly movieFriendlyUrl = input.required<string>();
  readonly typeFormUrl = input.required<string>();
  readonly typeFormData = input.required<string>();

  ngAfterViewInit(): void {
    this.insertTypeformScript();
  }

  ngOnDestroy(): void {
    this.movieCompetitionService.disableTypeformScript(this.movieFriendlyUrl());
  }

  private insertTypeformScript(): void {
    if (!this.typeFormUrl()) {
      return;
    }

    this.movieCompetitionService.initTypeformCompetition(this.movieFriendlyUrl(), this.typeFormUrl());
  }
}
